"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pridat = void 0;
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../..");
var hooks_1 = require("../../../../hooks");
var ZahranicniAdresaField_1 = require("../AddressField/ZahranicniAdresaField");
var Jazyky_1 = __importDefault(require("./Jazyky"));
var H2 = styled_components_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 28px;\n  margin-top: 0;\n  color: #000000;\n"], ["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 28px;\n  margin-top: 0;\n  color: #000000;\n"])));
exports.Pridat = styled_components_1.default(__1.LinkButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"])));
var StyledInfoDiv = styled_components_1.default(ZahranicniAdresaField_1.InfoDiv)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 10px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #333333;\n  ", "\n"], ["\n  padding: 10px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #333333;\n  ",
    "\n"])), function (_a) {
    var $error = _a.$error;
    return $error && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border: 1px solid red;\n    "], ["\n      border: 1px solid red;\n    "])));
});
var filterAvailable = function (selectedIds) { return ramda_1.filter(function (jazyk) { return !ramda_1.includes(jazyk.id, selectedIds); }); };
var mapToOptions = ramda_1.map(function (jazyk) { return ({ value: jazyk.id, label: jazyk.nazev }); });
var JazykyField = function (_a) {
    var name = _a.name, label = _a.label;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = hooks_1.useCiselnik('jazyky'), loading = _c.loading, error = _c.error, jazyky = _c.data;
    var _d = hooks_1.useCiselnik('jazykSpecializace'), loadSpec = _d.loading, errorSpec = _d.error, specializace = _d.data;
    var value = field.value || [];
    if (loading || loadSpec) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error || errorSpec) {
        return react_1.default.createElement(react_1.default.Fragment, null, error || errorSpec);
    }
    var handleChange = function (index) { return function (idJazyku) {
        var jazyk = jazyky === null || jazyky === void 0 ? void 0 : jazyky.find(function (j) { return j.id === idJazyku; });
        if (typeof idJazyku === 'object') {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), idJazyku, value));
        }
        else if (jazyk) {
            helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), jazyk, value));
        }
    }; };
    var handleAdd = function () {
        helpers.setValue(ramda_1.append({}, value));
    };
    var handleRemove = function (index) { return function () {
        helpers.setValue(ramda_1.remove(index, 1, value));
    }; };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(H2, null, label),
        ramda_1.addIndex(ramda_1.map)(function (jazyk, index) {
            var usedIds = ramda_1.without([jazyk.id], ramda_1.pluck('id', field.value));
            var options = ramda_1.pipe(filterAvailable(usedIds), mapToOptions)(jazyky || []);
            return (react_1.default.createElement(Jazyky_1.default, { key: jazyk.id || "create-" + index, jazyk: jazyk, onChange: handleChange(index), onRemove: handleRemove(index), options: function () { return Promise.resolve(options); }, specs: specializace }));
        }, value),
        !value ||
            (!value.length && (react_1.default.createElement(StyledInfoDiv, { "$error": !!meta.error },
                react_1.default.createElement(__1.BulbIcon, null),
                label,
                " nejsou specifikov\u00E1ny."))),
        react_1.default.createElement(exports.Pridat, { type: "button", onClick: handleAdd, name: "PridatJazyk" }, "+ P\u0159idat jazyk")));
};
exports.default = JazykyField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
